module.exports = __webpack_public_path__ + "images/marketing/pipelinedeals-logo-on-white.gif";